import { useState, useRef, useCallback } from 'react'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import CalendarHeader from './calendarHeader'
import CalendarContent from './calendarContent'
import { Box } from '@mui/material'

const LeaveCalendar = () => {
  const [calendarValue, setCalendarValue] = useState(new Date())
  const [calendarFilter, setCalendarFilter] = useState({
    holiday: true,
    leave: true,
    birthday: true,
    anniversary: true,
  })
  const [apiFilter, setApiFilter] = useState([])
  const divRef = useRef([])

  const scrollToDiv = (index) => {
    if (divRef.current[index]) {
      divRef.current[index].scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const handleClick = useCallback((index) => {
    scrollToDiv(index)
  }, [])

  return (
    <DashboardContainer headerTitle="Calendar">
      <Box display={'flex'} flexDirection={'column'} gap={2}>
        <CalendarHeader
          calendarValue={calendarValue}
          setCalendarValue={setCalendarValue}
          calendarFilter={calendarFilter}
          setCalendarFilter={setCalendarFilter}
          handleClick={handleClick}
          apiFilter={apiFilter}
          setApiFilter={setApiFilter}
        />
        <CalendarContent
          ref={divRef}
          calendarValue={calendarValue}
          filters={calendarFilter}
          apiFilter={apiFilter}
        />
      </Box>
    </DashboardContainer>
  )
}

export default LeaveCalendar
